'use client'

import { stadiums } from '@/content/world-cup-2026/data'

/**
 * Open the target stadium's transit `<details>` so "How to get there" both jumps
 * to the section and expands it. The `href` still drives the scroll (and is the
 * no-JS fallback); this only flips the accordion open.
 */
const expandTransit = (stadiumId: string) => {
    const details = document.getElementById(`${stadiumId}-transit`)
    if (details instanceof HTMLDetailsElement) {
        details.open = true
    }
}

/** Jump-link directory of all host-city stadiums, with per-stadium sub-links. */
export const WcStadiumToc = () => (
    <nav
        id="toc"
        className="mb-12 scroll-mt-[124px] rounded-b-lg border border-t-[3px] border-[var(--wc-border)] border-t-[var(--wc-blu-700)] bg-white px-6 py-[22px] shadow-[var(--wc-shadow-1)]"
    >
        <div className="mb-[18px] text-[11px] font-bold tracking-[0.14em] text-[var(--wc-blu-700)] uppercase">
            Stadiums
        </div>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(212px,1fr))] gap-x-6 gap-y-[15px]">
            {stadiums.map((s) => (
                <div key={s.id}>
                    <div className="mb-[3px] text-sm font-bold">
                        <a
                            href={`#${s.id}`}
                            className="text-[var(--wc-fg)] hover:text-[var(--wc-blu-700)]"
                        >
                            {s.name}
                        </a>
                    </div>
                    <div className="text-xs text-[var(--wc-fg-muted)]">
                        <a href={`#${s.id}-schedule`} className="text-xs text-[var(--wc-blu-700)]">
                            Schedule
                        </a>
                        <span className="mx-[7px] inline-block h-[5px] w-[5px] rounded-full bg-[var(--wc-smoke-500)] align-middle" />
                        <a
                            href={`#${s.id}-transit`}
                            onClick={() => expandTransit(s.id)}
                            className="text-xs text-[var(--wc-blu-700)]"
                        >
                            How to get there
                        </a>
                    </div>
                </div>
            ))}
        </div>
    </nav>
)
